import React, { FC } from "react";
import "./FooterLogin.scss";

interface IFooterLogin {}

const FooterLogin: FC<IFooterLogin> = () => {
  return (
    <div className="footer text-medium-14">
      <span>© 2024 Leopart. All Rights Reserved.</span>
      <div className="container__right">
        <a href="/privacy" className="pe-4" style={{ color: 'inherit', textDecoration: 'underline' }}>
          Privacy Policy
        </a>
        <a href="/terms" style={{ color: 'inherit', textDecoration: 'underline' }}>
          Termini e condizioni
        </a>
      </div>
    </div>
  );
};

export default FooterLogin;
